import { render, staticRenderFns } from "./ProtocolOnProlongationList.vue?vue&type=template&id=0279e20f"
import script from "./ProtocolOnProlongationList.vue?vue&type=script&lang=js"
export * from "./ProtocolOnProlongationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports